import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { gql } from '../../utils/gqlClient';
import { wrapQuery } from '../../utils/wrapQuery';
import { getClientId } from '../../utils/config';
var query = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query RefreshToken($client: String!) {\n    refreshToken(clientId: $client) {\n      tokens {\n        accessToken\n        idToken\n        expires\n      }\n    }\n  }\n"])));
function refresh() {
  return _refresh.apply(this, arguments);
}
function _refresh() {
  _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return wrapQuery('refresh', query, {
            client: getClientId()
          });
        case 2:
          data = _context.sent;
          return _context.abrupt("return", data.refreshToken.tokens);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _refresh.apply(this, arguments);
}
export { refresh };